var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeGrey(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "18px",
    viewBox: "0 0 25 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "eye") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Row-Drivers",
    transform: "translate(-1293.000000, -31.000000)",
    fill: "#979598"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye",
    transform: "translate(1293.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4928406,13.5744144 C15.2019359,13.5921963 17.4414789,11.3633502 17.4566996,8.63411135 C17.4717636,5.90431677 15.2915399,3.69908729 12.5334054,3.65435478 C9.83820215,3.61059471 7.58059952,5.84166347 7.55267643,8.5764592 C7.52475334,11.3116717 9.74345814,13.5563547 12.4928406,13.5744144 M12.8672322,17.276377 C10.317618,17.1288431 8.23074907,16.583301 6.25904553,15.5943235 C4.26761523,14.5954826 2.54833087,13.2517013 1.09646913,11.5611735 C-0.3673398,9.85689262 -0.385399509,7.31352981 1.16231761,5.62050148 C2.85492917,3.76924232 4.83580149,2.26667447 7.11507577,1.19420556 C10.4707088,-0.384629834 13.8735748,-0.340869768 17.2890827,0.98901947 C19.9953996,2.04273407 22.3132939,3.65129852 24.1142637,5.94877144 C25.3899739,7.5760902 25.2591104,9.99581346 23.9057436,11.5631184 C21.7251031,14.0888383 19.0443476,15.8259045 15.8308306,16.7016615 C14.7548887,16.9949234 13.6361591,17.1309269 12.8672322,17.276377",
    id: "Fill-1"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeGrey);
export default __webpack_public_path__ + "static/media/eye-grey.1a6f7e52ee260ec64411051e6c51f842.svg";
export { ForwardRef as ReactComponent };